




















import { Component, Vue, Watch } from 'vue-property-decorator';
import Axios from 'axios';
import firebase from 'firebase';
import Menulist from './components/MenuList.vue';
import {FirebaseConnection, Config, Authentications} from './Classes/Infrastractures';
import {DataInitializeUsecase} from './Classes/Usecases';
import { State, Getter, Mutation} from 'vuex-class';
import { FunctionsState } from './stores/functions/types';
import { Functions, Function } from './Classes/Entities';
import { LoginState } from './stores/login/types';
import { Route } from 'vue-router';

const namespace: string = 'functions';

Component.registerHooks(
  [
    'beforeRouteEnter'
  ]
);

@Component
export default class App extends Vue {
}
